<template>
  <Fragment>
    <ModalBase v-bind="{ ...$attrs, open, className }" v-on="$listeners">
      <slot />
    </ModalBase>
    <div :class="['backdrop', { open }]" @click="$emit('closeclick', $event)" />
  </Fragment>
</template>

<script>
import ModalBase from '@/components/ModalBase';
import { Fragment } from 'vue-fragment';

export default {
  name: 'ModalWithBackdrop',

  components: { ModalBase, Fragment },

  props: {
    open: { type: Boolean, default: false },
    className: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
